import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "image-edit" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  key: 0,
  class: "upload-section"
}
const _hoisted_4 = { class: "upload-label" }
const _hoisted_5 = {
  key: 1,
  class: "image-preview"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }

import { ref, watch } from "vue";

interface Props {
  block: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageEdit',
  props: {
    block: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const localBlock = ref(JSON.parse(JSON.stringify(props.block)));

// Inicializar dados se não existirem
if (!localBlock.value.data) {
  localBlock.value.data = {
    src: "",
    alt: "Imagem do relatório",
    caption: "",
  };
}

if (!localBlock.value.style) {
  localBlock.value.style = {
    textAlign: "center",
    maxWidth: "100%",
    margin: "20px 0",
    border: "none",
  };
}

watch(
  () => props.block,
  (newBlock) => {
    localBlock.value = JSON.parse(JSON.stringify(newBlock));
  },
  { deep: true }
);

function onChange() {
  emit("update", localBlock.value);
}

function onFileUpload(event: Event) {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];

  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      localBlock.value.data.src = e.target?.result as string;
      localBlock.value.data.alt = file.name;
      onChange();
    };
    reader.readAsDataURL(file);
  }
}

function removeImage() {
  localBlock.value.data.src = "";
  localBlock.value.data.alt = "Imagem do relatório";
  onChange();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("h4", null, "Editar Imagem", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("label", null, "URL da Imagem:", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localBlock.value.data.src) = $event)),
        onInput: onChange,
        type: "text",
        placeholder: "https://exemplo.com/imagem.jpg"
      }, null, 544), [
        [_vModelText, localBlock.value.data.src]
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("small", null, "Cole a URL da imagem ou faça upload", -1))
    ]),
    (!localBlock.value.data.src)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createElementVNode("input", {
              type: "file",
              onChange: onFileUpload,
              accept: "image/*",
              class: "upload-input"
            }, null, 32),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "upload-area" }, [
              _createElementVNode("span", null, "📁"),
              _createElementVNode("p", null, "Clique para fazer upload de uma imagem")
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (localBlock.value.data.src)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            src: localBlock.value.data.src,
            alt: localBlock.value.data.alt,
            class: "preview"
          }, null, 8, _hoisted_6),
          _createElementVNode("button", {
            onClick: removeImage,
            type: "button",
            class: "btn-remove-image"
          }, " Remover Imagem ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _cache[10] || (_cache[10] = _createElementVNode("label", null, "Texto Alternativo:", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localBlock.value.data.alt) = $event)),
        onInput: onChange,
        type: "text",
        placeholder: "Descrição da imagem"
      }, null, 544), [
        [_vModelText, localBlock.value.data.alt]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[11] || (_cache[11] = _createElementVNode("label", null, "Legenda:", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localBlock.value.data.caption) = $event)),
        onInput: onChange,
        type: "text",
        placeholder: "Legenda da imagem"
      }, null, 544), [
        [_vModelText, localBlock.value.data.caption]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[13] || (_cache[13] = _createElementVNode("label", null, "Alinhamento:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localBlock.value.style.textAlign) = $event)),
        onChange: onChange
      }, [...(_cache[12] || (_cache[12] = [
        _createElementVNode("option", { value: "left" }, "Esquerda", -1),
        _createElementVNode("option", { value: "center" }, "Centro", -1),
        _createElementVNode("option", { value: "right" }, "Direita", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.textAlign]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[15] || (_cache[15] = _createElementVNode("label", null, "Largura Máxima:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localBlock.value.style.maxWidth) = $event)),
        onChange: onChange
      }, [...(_cache[14] || (_cache[14] = [
        _createElementVNode("option", { value: "100%" }, "100%", -1),
        _createElementVNode("option", { value: "75%" }, "75%", -1),
        _createElementVNode("option", { value: "50%" }, "50%", -1),
        _createElementVNode("option", { value: "25%" }, "25%", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.maxWidth]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[17] || (_cache[17] = _createElementVNode("label", null, "Margem:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localBlock.value.style.margin) = $event)),
        onChange: onChange
      }, [...(_cache[16] || (_cache[16] = [
        _createElementVNode("option", { value: "10px 0" }, "Pequena", -1),
        _createElementVNode("option", { value: "20px 0" }, "Normal", -1),
        _createElementVNode("option", { value: "30px 0" }, "Grande", -1),
        _createElementVNode("option", { value: "40px 0" }, "Muito Grande", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.margin]
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[19] || (_cache[19] = _createElementVNode("label", null, "Borda:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localBlock.value.style.border) = $event)),
        onChange: onChange
      }, [...(_cache[18] || (_cache[18] = [
        _createElementVNode("option", { value: "none" }, "Sem Borda", -1),
        _createElementVNode("option", { value: "1px solid #ddd" }, "Borda Leve", -1),
        _createElementVNode("option", { value: "2px solid #333" }, "Borda Média", -1),
        _createElementVNode("option", { value: "3px solid #007bff" }, "Borda Destacada", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.border]
      ])
    ])
  ]))
}
}

})